<div class="page-not-found">
    <div class="mat-display-4">
        <span>4</span><span style="color: #eeb89e;">0</span><span>4</span>
    </div>
    <h2>Page Not Found</h2>
    <h3>The page you were looking for could not be found</h3>
    <br> <br>
    <button color="primary" mat-flat-button class="square-flat-button" [routerLink]="['/']">Back to home page</button>
</div>